export const TRACKING_ID_KEY = 'trackingId';

export type StorageHost = {
  sessionStorage: Pick<Storage, 'clear'>;
  localStorage: Pick<Storage, 'removeItem'>;
};

/**
 * OTT-1988 / PT-07 — clear browser-side state that must not outlive a session.
 *
 * sessionStorage is cleared wholesale (it holds `user`, `site`, `packageConfig`,
 * `appCardConfig`, `siteMode`, `topicPageBreadcrumb`); localStorage is cleared
 * SELECTIVELY, because third-party vendors (Hotjar `_hj*`, ReciteMe) keep their
 * own keys there and wiping those is not ours to do.
 *
 * The storage host is injectable so this is testable under Jest's `node`
 * environment — there is no jsdom in this repo.
 */
const clearClientStorage = (host?: StorageHost): void => {
  const target: StorageHost | undefined =
    host ?? (typeof window === 'undefined' ? undefined : window);
  if (!target) return;

  try {
    target.sessionStorage.clear();
  } catch {
    // storage can throw in private-mode / disabled-storage browsers
  }

  try {
    target.localStorage.removeItem(TRACKING_ID_KEY);
  } catch {
    // as above
  }
};

export default clearClientStorage;
